import React from "react";
import { ParameterDataType } from "../../types/Category";
import ParameterInputString, {ParameterFilterInputPropsString} from "./ParameterFilterInputString";
import ParameterFilterInputBoolean, {ParameterFilterInputPropsBoolean} from "./ParameterFilterInputBoolean";
import ParameterFilterInputNumber, {ParameterFilterInputPropsNumber} from "./ParameterFilterInputNumber";
import ParameterInputSelectable, {ParameterFilterInputPropsSelectable} from "./ParameterFilterInputSelectable";

type ParameterInputFieldProps =
    | ParameterFilterInputPropsString
    | ParameterFilterInputPropsBoolean
    | ParameterFilterInputPropsNumber
    | ParameterFilterInputPropsSelectable;


/* ============================================================
 * Dispatcher Component
 * ============================================================ */

const ParameterInputField: React.FC<ParameterInputFieldProps> = (props) => {
    switch (props.dataType) {
        case ParameterDataType.STRING:
            return <ParameterInputString {...props} />;

        case ParameterDataType.BOOLEAN:
            return <ParameterFilterInputBoolean {...props} />;

        case ParameterDataType.INTEGER:
        case ParameterDataType.DOUBLE:
            return <ParameterFilterInputNumber {...props} />;

        case ParameterDataType.SELECTABLE:
            return <ParameterInputSelectable {...props} />;

        default:
            return null;
    }
};

export default ParameterInputField;